// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"fe31d9ae","258":"446966c7","265":"e6379494","442":"58db48f2","660":"e0592c67","722":"fddaaacd","787":"4ba9c1da","842":"c28a38e3","882":"c538b3c0","987":"c0301882"}[chunkId] + ".chunk.js";
};